import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatesSelector from './dates-selector';
import DeviceSelector from './device-selector';
import SourceSelector from './source-selector';
import ClearFilters from './clear-filters';
import { isRollingStone as isRSSpotId } from '../../../services/spot-storage';
import classnames from 'classnames';

class MonetizationHeader extends Component {
  static displayName = 'AnalyticsHeader';

  static propTypes = {
    headerText: PropTypes.string.isRequired,
    pageInfo: PropTypes.object.isRequired,
    onFiltersChange: PropTypes.func,
    spotId: PropTypes.string
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  render() {
    var { pageInfo, headerText, onFiltersChange, spotId } = this.props;
    const isRollingStone = isRSSpotId(spotId);

    return (
      <div
        className={classnames('analytics-header monetization-header', {
          'no-source-selector': isRollingStone
        })}
      >
        <span className="analytics-title">{headerText}</span>
        <DatesSelector pageInfo={pageInfo} onFiltersChange={onFiltersChange} />
        <DeviceSelector pageInfo={pageInfo} onFiltersChange={onFiltersChange} />
        {!isRollingStone && (
          <SourceSelector pageInfo={pageInfo} onFiltersChange={onFiltersChange} />
        )}
        <ClearFilters onFiltersChange={onFiltersChange} />
      </div>
    );
  }
}

export default MonetizationHeader;
